import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { feedFactoryAxios, setAuthToken } from "@feed-factory/feed-factory.helpers";


setAuthToken('6ac83e1d-f100-44b6-a6cf-f81c7cbeed75');
feedFactoryAxios.defaults.baseURL = 'https://app.thefeedfactory.nl/api';

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
